<template>
    <b-row class="animated fadeIn" v-if="ready">
        <b-col cols="12" md="6">
            <b-card>
                <b-form @submit="save">
                    <InputField name="name" :label="this.$t('name')" v-model="model.name" @error="fieldError"
                        :disabled="true" :rules="{ required: true, length: { min: 2 } }" />

                    <InputField type="email" name="email" :label="this.$t('email')" v-model="model.email"
                        @error="fieldError" :disabled="true" :rules="{ required: true, length: { min: 2 } }" />

                    <b-form-group :label="this.$t('role')">
                        <v-select :options="roles" v-model="model.roles" multiple label="name" />
                    </b-form-group>

                    <b-form-group>
                        <button class="btn btn-success" type="submit">{{ $t('save') }}</button>
                        <button class="btn btn-danger ml-2" @click="remove">{{ $t('delete') }}</button>
                    </b-form-group>
                </b-form>
            </b-card>
        </b-col>
        <b-col cols="12" md="6">
            <b-card>
                <small style="color:#ccc"> {{ $t('userCustomFieldsDescription') }} </small>
                <b-row cols="3" class="mt-2" v-for="(field, idx) in model.custom_fields" :key="idx">
                    <b-col><b-input v-model="model.custom_fields[idx].key" :placeholder="$t('key')" /></b-col>
                    <b-col><b-input v-model="model.custom_fields[idx].value" :placeholder="$t('value')" /></b-col>
                    <b-col cols="1"><b-icon icon="trash" class="removeKey" @click="removeCustomField(idx)" /></b-col>
                </b-row>
                <b-row cols="1" class="mt-2">
                    <b-col><b-button variant="success" @click="addCustomField"> {{ $t('add') }} </b-button></b-col>
                </b-row>
            </b-card>
        </b-col>
    </b-row>
</template>

<style scoped>
.removeKey {
    cursor: pointer;
    margin-top: 5px;
}

.removeKey:hover {
    color: #ccc;
}
</style>

<script>
import Input from "@/components/form/Input"
import Select from "@/components/form/Select"
import VSelect from "vue-select"

export default {
    name: "Edit",
    components: {
        InputField: Input,
        SelectField: Select,
        VSelect
    },
    data: function () {
        return {
            ready: false,
            errors: [],
            model: {
                roles: [],
                custom_fields: []
            },
        }
    },

    computed: {
        roles() {
            return this.$store.getters.getRoles
        },

        // userRoles: {
        //     set(val) {
        //         console.log("userRoles.set", val)
        //         this.model.roles = val
        //     },

        //     get() {
        //         return this.model.roles.map(r => {
        //             return {
        //                 label: r.role.name,
        //                 value: r.role_uuid
        //             }
        //         })
        //     }
        // },

        fields: {
            get() {
                return this.model.custom_fields || []
            },

            set(val) {
                this.model.custom_fields = val
            }
        }
    },
    methods: {
        removeCustomField(idx) {
            this.model.custom_fields.splice(idx, 1)
        },

        save(e) {
            e.preventDefault()

            if (this.checkForErrors()) {
                this.$mainDialog.msgBoxOk(this.$t('fieldsNotValid'))

                return
            }

            this.$http.put("/v1/project/user/" + this.$route.params.id, this.model).then((resp) => {

                this.$bvToast.toast(this.$t('userSaved'), {
                    variant: 'success',
                    title: "Success"
                })
            }).catch(error => {
                if (error.response) {
                    if (error.response.status == 500) {
                        this.$serverErrorModal(error)
                        return
                    }

                    this.$mainDialog.msgBoxOk(error.response.data.message)
                }
            })
        },

        remove(e) {
            e.preventDefault()

            this.$mainDialog.msgBoxOk(`${this.$t('areYouSure')}?`).then(resp => {
                if (resp) {
                    this.$http.delete("/v1/project/user/" + this.$route.params.id).then((resp) => {
                        this.$store.commit('PROJECT_DELETE_USER', this.$route.params.id)
                        this.$router.push({ path: "/admin/iam" })
                    }).catch(error => {
                        if (error.response.status == 500) {
                            this.$serverErrorModal(error)
                            return
                        }

                        this.$mainDialog.msgBoxOk(error.response.data.message)
                    })
                }
            })
        },

        fieldError(error) {
            let found = this.errors.find((i, e) => {
                return i.field == error.field
            })

            if (found === undefined) {
                this.errors.push(error)
            } else {
                this.errors.map(e => {
                    if (found.field == e.field)
                        e.error = error.error
                })
            }
        },

        checkForErrors() {
            return this.errors.find((i, e) => {
                return i.error
            })
        },

        addCustomField() {
            this.fields.push({
                key: "",
                value: ""
            })
        }
    },
    mounted() {
        this.$store.dispatch("fetchRoles").catch(error => {
            if (error.response.status == 500) {
                this.$serverErrorModal(error)
                return
            }

            this.$mainDialog.msgBoxOk(error.response.data.message)
        })

        this.$http.get("/v1/project/user/" + this.$route.params.id).then((resp) => {
            this.model = resp.data
            this.model.roles = this.model.roles.map(r => {
                return r.role
            })

            console.log("model", this.model)

            this.ready = true
        }).catch(error => {
            if (error.response.status == 500) {
                this.$serverErrorModal(error)
                return
            }

            this.$mainDialog.msgBoxOk(error.response.data.message)
        })
    }
}
</script>
